import { useContext } from 'react';

import { HoneycombDatasetTypeContext } from '../context/honeycomb-dataset-type.context.js';

export const useHoneycombDatasetType = () =>
  useContext(HoneycombDatasetTypeContext);
